import OpenInNewIcon from "@mui/icons-material/OpenInNew";

import { defaultButton, defaultDescription, defaultId, defaultName, defaultTime, defaultStyle, defaultThumbnail } from "./shared.js";

// Custom functions for table columns.
const getThumbnail = (props, params) => {
    return params.row?.meta_data?.thumbnail;
};

const urlTitle = (props, params) => {
    return "Source";
};

const clickUrl = (props, params) => {
    const url = params.row.url;
    window.open(url, "_blank");
};

const disableUrl = (props, params) => {
    const url = params.row.url;
    return !url;
};

const playlistResourceIds = (params) => params.row.resource_ids || [];

const disablePlaylistView = (props, params) => playlistResourceIds(params).length === 0;

const applyIdFilterAndNavigate = (tableState, columnField, ids, path, props) => {
    tableState.setFilter({
        items: [{ columnField, operatorValue: "isAnyOf", value: ids }],
        quickFilterValues: []
    });
    tableState.setPage(0);
    props.browser.navigate(path);
};

const clickViewResources = (props, params) => {
    applyIdFilterAndNavigate(props.backend.resources, "id", playlistResourceIds(params), "/database/resources", props);
};

const clickViewTranscripts = (props, params) => {
    applyIdFilterAndNavigate(props.backend.transcripts, "resource_id", playlistResourceIds(params), "/database/transcripts", props);
};

// Column definitions.
const name = { ...defaultName, minWidth: 150 };
const description = { ...defaultDescription, minWidth: 200 };
const thumbnail = (props) => {
    return { ...defaultThumbnail(props, { thumbnail: getThumbnail }), headerName: "Thumbnail", minWidth: 100, flex: 0.1 };
};
const createdOn = { ...defaultTime("created_on"), headerName: "Created on" };
const updatedOn = { ...defaultTime("updated_on"), headerName: "Updated on" };
const library = {
    ...defaultStyle,
    field: "library.name",
    headerName: "Library",
    flex: 0.1,
    minWidth: 100,
    valueGetter: (params) => params.row.library?.name || ""
};
const videos = {
    ...defaultStyle,
    field: "resource_count",
    headerName: "Videos",
    flex: 0.05,
    minWidth: 70,
    valueGetter: (params) => params.row.resource_count ?? 0
};
const url = (props) => {
    return {
        ...defaultButton(props, { onClick: clickUrl, disabled: disableUrl, title: urlTitle, endIcon: <OpenInNewIcon />, variant: "outlined" }),
        field: "url",
        headerName: "URL",
        minWidth: 105,
        flex: 0.1
    };
};
const viewResources = (props) => {
    return {
        ...defaultButton(props, { onClick: clickViewResources, disabled: disablePlaylistView, title: "View" }),
        field: "view_resources",
        headerName: "View Resources",
        minWidth: 130,
        flex: 0.1
    };
};
const viewTranscripts = (props) => {
    return {
        ...defaultButton(props, { onClick: clickViewTranscripts, disabled: disablePlaylistView, title: "View" }),
        field: "view_transcripts",
        headerName: "View Transcripts",
        minWidth: 145,
        flex: 0.1
    };
};

// Table columns.
export const columns = (props) => [
    defaultId,
    name,
    description,
    thumbnail(props),
    videos,
    library,
    url(props),
    createdOn,
    updatedOn,
    viewResources(props),
    viewTranscripts(props)
];

// Style and other misc. functions.
export const isRowSelectable = (props, params) => {
    return true;
};

// Default aggregate props of the table.
export const defaultTableOptions = {
    isRowSelectable,
    checkboxSelection: true
};
